// Bridges primereact@9.6.4 ↔ @sl/react-datafabric-components@1.1.4 (built
// against primereact@10.x). MUST be the first import so the polyfills land
// on ObjectUtils before any wrapper component touches it. Hits show up as
// `TypeError: ht.getItemValue is not a function` from the wrapper's
// minified bundle — currently the candidate Research panel <Tree>.
import "./common/primereact-compat-shim";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css"; // core PrimeReact CSS
// Quill snow theme — REQUIRED for the PrimeReact <Editor>. Without it the
// .ql-editor content area is unstyled, which breaks how lists (<ul>/<ol>),
// blockquotes and code blocks render in the article approval editor
// (paragraphs looked "cut off after the colon" because list items rendered
// with no marker/indent). Article DATA was always intact — this is display.
import "quill/dist/quill.snow.css";
import "./app2.css";
import "./styles/freya/layout.scss";
import "./styles/freya/theme/theme-dark/turquoise/theme.scss";
import "/node_modules/flag-icons/css/flag-icons.min.css";

import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "./redux/store";
// import loadable from '@loadable/component';
//MENE: import { I18nProvider } from '@slone/ui-fabric-i18n'; removed from the render <Provider store={store}> <I18nProvider><UiToolkitProvider>
import {
  ConfirmDialogProvider,
  ToastProvider,
  UiToolkitProvider,
} from "@sl/react-datafabric-components";
import "./App.css";
import ErrorPage from "./common/app/error/page";
import { ErrorBoundary } from "./common/components/error-boundary/index";
import { AgentContextProvider } from "./common/context/agent.provider";
import { router } from "./router";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function isEnvFlagEnabled(value: unknown): boolean {
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  return (
    normalized === "true" ||
    normalized === "1" ||
    normalized === "yes" ||
    normalized === "on"
  );
}

async function disableMockingIfRegistered() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(
    registrations
      .filter((registration) =>
        registration.active?.scriptURL?.includes("mockServiceWorker.js")
      )
      .map((registration) => registration.unregister())
  );
}

async function enableMocking() {
  const shouldEnableMocking = isEnvFlagEnabled(import.meta.env.VITE_MOCK_PORTAL);

  if (!shouldEnableMocking) {
    await disableMockingIfRegistered();
    return;
  }

  const { serviceWorker } = await import("../mocks/browser");
  return serviceWorker.start({ onUnhandledRequest: "bypass" });
}

enableMocking().then(() => {
  root.render(
    <ErrorBoundary fallback={<ErrorPage />}>
      <link rel="stylesheet" href="./app.css" />
      {/* font for auth pages */}
      <link
        href="https://fonts.googleapis.com/css2?family=Offside&display=swap"
        rel="stylesheet"
      />

      <Provider store={store}>
        <UiToolkitProvider>
          <ToastProvider>
            <ConfirmDialogProvider>
              <ErrorBoundary fallback={<ErrorPage />}>
                <AgentContextProvider>
                  {" "}
                  {/* Use the new provider */}
                  <RouterProvider router={router} />
                </AgentContextProvider>
              </ErrorBoundary>
            </ConfirmDialogProvider>
          </ToastProvider>
        </UiToolkitProvider>
      </Provider>
    </ErrorBoundary>
  );
});
